export enum ObjectState {
  Complete = 'kompletny',
  Assigned = 'przypisany',
  Uploaded = "wgrana_g",
  AnalysisInProgress = "analiza_wt",
  AnalysisSuccess = "analiza_s",
  AnalysisDecision = "analiza_d",
  AnalysisError = "analiza_b",
  DownloadedForEdition = 'pobrane_e',
  WaitingRoomEdition = 'poczekalnia_e',
  NoGeometry = 'brak_g',
  ToBeVerified = 'do_weryfikacji',
  DownloadedForVerification = 'pobrane_w',
  WaitingRoomEditionVerification = 'poczekalnia_w',
  ToBeCorrected = 'do_poprawy',
  Accepted = 'zatwierdzony'
}

export enum ProcessMarker {
  A = 'a',
  K = 'k',
  N = 'n',
  O = 'o',
  U = 'u'
}